export default function SystemStatusBanner({ loading, failed }: { loading: boolean; failed: boolean }) {
  return <div className="mx-5 mt-4 rounded-2xl border border-gray-200 bg-white px-4 py-3 text-xs text-gray-600" role="status">
    数据读取状态 · {loading ? '读取中' : failed ? '部分数据未读取' : '本次读取完成'}
    <p className="mt-1 text-gray-400">读取完成不代表账户可交易或系统健康。</p>
  </div>;
}
